import React from 'react';
import cn from 'classnames';
import { NodeViewWrapper } from '@tiptap/react';
import DaVideoPlayer from '../DaVideoPlayer';
import { useSize } from '../../hooks/useSize';
import { useEditorContainerSize } from '../../../../components/Editor/Context';
import s from './DaVideoView.scss';
import viewerStyles from '../../Viewer/Viewer.scss';
const VideoNodeView = ({ node: { attrs }, extension: { options } })=>{
    const containerSize = useEditorContainerSize();
    const { width, height } = useSize(options.defaultWidth, options.defaultHeight, attrs.alignment, containerSize !== null && containerSize !== void 0 ? containerSize : 0);
    return /*#__PURE__*/ React.createElement(NodeViewWrapper, {
        "data-da-type": "da-video",
        "data-src": attrs.src,
        "data-drag-handle": "true",
        className: cn('draggable-atomic')
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(viewerStyles['video-wrapper'], viewerStyles[attrs.alignment], options.smallMedia && viewerStyles['small-media'])
    }, /*#__PURE__*/ React.createElement(DaVideoPlayer, {
        src: attrs.src,
        width: width,
        height: height,
        className: s['video-player']
    })));
};
export default VideoNodeView;

//# sourceMappingURL=DaVideoView.js.map